export default __webpack_public_path__ + "static/product1-fa3291fae6bee443deb44c69817aefa1.png";